module.exports = __webpack_public_path__ + "media/images/iconLeft__inactive--dark-de6d6ef191a2ab4d1fa5743fa69aff86.png";